import {Component, Input, NgModule} from '@angular/core';

const ICON_ALIASES: Record<string, string> = {
  'alert-circle': 'warning',
  'alertcircle': 'warning',
  'check-circle-2': 'check_circle',
  'checkcircle2': 'check_circle',
  clock: 'schedule',
  download: 'download',
  eye: 'visibility',
  'eye-off': 'visibility_off',
  eyeoff: 'visibility_off',
  'file-text': 'description',
  filetext: 'description',
  'key-round': 'key',
  keyround: 'key',
  save: 'save',
  x: 'close',
  calendar: 'calendar_month',
  'circle-check': 'check_circle',
  circlecheck: 'check_circle',
  'circle-x': 'cancel',
  circlex: 'cancel',
  'clipboard-check': 'fact_check',
  clipboardcheck: 'fact_check',
  copy: 'content_copy',
  landmark: 'account_balance',
  smartphone: 'smartphone',
  wallet: 'wallet',
  'x-circle': 'cancel',
  xcircle: 'cancel',
  building2: 'apartment',
  'building-2': 'apartment',
  'chevron-down': 'expand_more',
  chevrondown: 'expand_more',
  upload: 'upload',
  link: 'link',
  unlink: 'link_off',
  check: 'check',
  plus: 'add',
  search: 'search',
  trash2: 'delete',
  'trash-2': 'delete',
  refreshcw: 'sync',
  'refresh-cw': 'sync',
  'plus-circle': 'add_circle',
  pluscircle: 'add_circle',
  folderclosed: 'folder',
  'folder-closed': 'folder',
  layoutdashboard: 'dashboard',
  'layout-dashboard': 'dashboard',
  logout: 'logout',
  'log-out': 'logout',
};

@Component({
  selector: 'lucide-icon',
  standalone: true,
  template: `
    <span class="material-symbols-outlined" [style.fontSize.px]="resolvedSize">{{ resolvedName }}</span>
  `,
  host: {
    class: 'inline-flex items-center justify-center leading-none align-middle',
    'aria-hidden': 'true',
  }
})
export class GoogleIconComponent {
  @Input() name: unknown = '';
  @Input() size: string | number = 16;

  get resolvedName(): string {
    const raw = String(this.name ?? '').trim();
    const key = raw.toLowerCase();
    return ICON_ALIASES[key] ?? raw;
  }

  get resolvedSize(): number {
    const parsed = Number(this.size);
    return Number.isFinite(parsed) ? parsed : 16;
  }
}

@NgModule({
  imports: [GoogleIconComponent],
  exports: [GoogleIconComponent]
})
export class LucideAngularModule {}

export const AlertCircle = 'warning';
export const CheckCircle2 = 'check_circle';
export const Clock = 'schedule';
export const Download = 'download';
export const Eye = 'visibility';
export const EyeOff = 'visibility_off';
export const FileText = 'description';
export const KeyRound = 'key';
export const Save = 'save';
export const X = 'close';
export const Calendar = 'calendar_month';
export const CircleCheck = 'check_circle';
export const CircleX = 'cancel';
export const ClipboardCheck = 'fact_check';
export const Copy = 'content_copy';
export const Landmark = 'account_balance';
export const Smartphone = 'smartphone';
export const Wallet = 'wallet';
export const XCircle = 'cancel';
export const Building2 = 'apartment';
export const ChevronDown = 'expand_more';
export const Upload = 'upload';
export const Link = 'link';
export const Unlink = 'link_off';
export const Check = 'check';
export const Plus = 'add';
export const Search = 'search';
export const Trash2 = 'delete';
export const RefreshCw = 'sync';
export const PlusCircle = 'add_circle';
export const FolderClosed = 'folder';
export const LayoutDashboard = 'dashboard';
export const LogOut = 'logout';
